export default {
  OssAuthAddress: {
    OssAuth: "/getOssAuth",
    createVodUploadAuth: "/createVodUploadAuth",
    refreshVodUploadAuth: "/refreshVodUploadAuth",
    attachmentSavePath: "/attachments",
  },

  OssConfig: {
    region: 'oss-cn-hangzhou',
    endpoint: 'oss-cn-hangzhou.aliyuncs.com',
    bucket: 'zhushi-img',
  },

  AttachmentApi: {
    save: "/attachments",
    delete: "/attachments/:attachmentId",
  },
};
